module.exports = __webpack_public_path__ + "img/11_114.9a437e73.png";